import React, { ReactNode, useMemo } from "react";
import { FormFieldErrorStyle as S } from "./FormFieldError.style";
import { ControllerFieldState, FieldValues, RegisterOptions } from "react-hook-form";

export const FormFieldError: React.FC<{
  nameOrHeader: ReactNode | string;
  fieldState: ControllerFieldState;
  rules?: RegisterOptions<FieldValues>;
  isSubmitted: boolean;
}> = ({ fieldState, rules, isSubmitted }) => {
  const message = useMemo(() => {
    if (fieldState.error?.message) {
      return fieldState.error?.message;
    }
    if (fieldState.error) {
      switch (fieldState.error.type) {
        case "required":
          return "Required";
        case "minLength":
          return `Must be at least ${rules?.minLength} characters long`;
        case "maxLength":
          return `It must be no longer than ${rules?.maxLength} characters`;
        default:
          return "Field has invalid input";
      }
    }
    return null;
  }, [fieldState.error]);
  return (
    <S.FormFieldError className="form-field-error">
      {isSubmitted || fieldState.isDirty || fieldState.isTouched ? message : null}
    </S.FormFieldError>
  );
};
